import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import API from "../api/api";
import { useNavigate } from "react-router-dom";

export default function PublicacionesCliente() {
  const [publicaciones, setPublicaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [operacionesPorPublicacion, setOperacionesPorPublicacion] = useState({});
  const nav = useNavigate();

  const getOperacionIdFromStorage = (ofertaId) => {
    try {
      const raw = localStorage.getItem("ofertaOperacionMap");
      if (!raw) return null;
      const map = JSON.parse(raw);
      return map?.[String(ofertaId)] || null;
    } catch (err) {
      console.error("Error leyendo operacionId desde storage:", err);
      return null;
    }
  };



  // GET /publicaciones/mis/

  const cargarPublicaciones = async () => {
    try {
      const resOps = await API.get("/operaciones/mis-movimientos/");
      const opsMap = {};
      (resOps.data || []).forEach((op) => {
        if (op.publicacion?.id) {
          opsMap[String(op.publicacion.id)] = op.id;
        }
      });
      setOperacionesPorPublicacion(opsMap);

      const res = await API.get("/publicaciones/mis/");
      const pubs = res.data;

      // Adjuntar ofertas
      const pubsConOfertas = await Promise.all(
        pubs.map(async (pub) => {
          const r = await API.get(`/ofertas/publicacion/${pub.id}/`);
          return {
            ...pub,
            ofertas: r.data,
          };
        })
      );

      setPublicaciones(pubsConOfertas);
    } catch (err) {
      console.error("Error cargando publicaciones", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarPublicaciones();
  }, []);

  if (loading)
    return <p className="text-center text-primary mt-10">Cargando...</p>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-primary">Mis publicaciones</h1>

      {publicaciones.length === 0 ? (
        <p className="text-slate-500">Aún no has creado publicaciones.</p>
      ) : (
        publicaciones.map((pub) => (
          <Card key={pub.id} className="space-y-4">
            {/* CABECERA */}
            <div>
              <h2 className="text-lg font-semibold text-primary">
                {pub.titulo}
              </h2>

              <p className="text-sm text-slate-600">
                Tipo: <span className="capitalize">{pub.tipo}</span>
              </p>

              <p className="text-sm text-slate-600">
                Monto publicado:{" "}
                <b>
                  {Number(pub.monto).toLocaleString("es-PY")} Gs
                </b>
              </p>

              <p className="text-sm text-slate-600">
                Estado:{" "}
                <b className={`capitalize ${
                    pub.estado === "activo"
                      ? "text-emerald-600"
                      : pub.estado === "pendiente"
                      ? "text-amber-600"
                      : "text-red-600"
                  }`}
                >
                  {pub.estado}
                </b>
              </p>

              <p className="text-xs text-slate-500 mt-1">
                Publicado: {new Date(pub.creado_en).toLocaleDateString()}
              </p>
            </div>

            {/* ARCHIVOS ADJUNTOS */}
            {pub.archivos_adjuntos.length > 0 && (
              <div>
                <h3 className="font-semibold text-primary text-sm mb-2">
                  Archivos adjuntos
                </h3>

                <ul className="space-y-1">
                  {pub.archivos_adjuntos.map((adj) => (
                    <li key={adj.id}>
                      <a
                        href={adj.archivo}
                        target="_blank"
                        className="text-blue-600 underline text-sm"
                      >
                        {adj.nombre}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* OFERTAS RECIBIDAS */}
            <div className="space-y-2">
              <h3 className="font-semibold text-primary text-sm">
                Ofertas recibidas ({pub.ofertas.length})
              </h3>

              {pub.ofertas.length === 0 ? (
                <p className="text-slate-500 text-sm">
                  No se recibieron ofertas aún.
                </p>
              ) : (
                pub.ofertas.map((of) => {
                  const operacionId =
                    of.operacion_id ||
                    getOperacionIdFromStorage(of.id) ||
                    operacionesPorPublicacion[String(pub.id)];

                  return (
                  <div
                    key={of.id}
                    className="border rounded p-3 bg-slate-50"
                  >
                    <p className="text-sm">
                      Oferta:{" "}
                      <b>{Number(of.monto).toLocaleString("es-PY")} Gs</b>
                    </p>

                    <p className="text-xs text-slate-600">
                      Comprador: {of.comprador_nombre}
                    </p>

                    <p
                      className={`text-xs font-semibold mt-1 ${
                        of.estado === "aceptada"
                          ? "text-emerald-600"
                          : of.estado === "rechazada"
                          ? "text-red-600"
                          : "text-amber-600"
                      }`}
                    >
                      Estado: {of.estado}
                    </p>

                    {of.estado === "aceptada" && (
                      <Button
                        className="!bg-accent !text-black mt-2"
                        disabled={!operacionId}
                        onClick={() => {
                          if (!operacionId) return;
                          nav("/chat-operacion", {
                            state: { operacionId }
                          });
                        }}
                      >
                        Ir al chat
                      </Button>
                    )}
                  </div>
                  );
                })
              )}
            </div>
          </Card>
        ))
      )}
    </div>
  );
}
